import { Component, OnInit, AfterContentInit } from '@angular/core';

import { FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmpreiteiraService } from 'src/app/pages/cadastros/empreiteira/empreiteira.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { UsuarioAutorizacoes } from 'src/app/models/usuario.autorizacoes.model';

@Component({
  selector: 'app-empreiteira',
  templateUrl: './empreiteira.component.html',
  providers: [EmpreiteiraService]
})
export class EmpreiteiraComponent implements OnInit, AfterContentInit {



  public cadastrados: any[] = [];
  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;
  public autorizacoes: UsuarioAutorizacoes;

  constructor(
    private empreiteiraService: EmpreiteiraService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService
  ) {}

  ngAfterContentInit(): void {
    this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('empreiteira');
  }

  ngOnInit() {
    this.list();
    this.resetForm(); // instancia o formulário utilizado (formGroup)
  }


  private list() {
    this.isLoading = true;
    this.empreiteiraService.list().subscribe(response => { this.cadastrados = response; this.isLoading = false; });
  }


  public resetForm(): void {
    this.form = new FormGroup(
      {
        id: new FormControl(0),
        nome: new FormControl('', [Validators.required, Validators.maxLength(20)])
      }
    );
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;
    this.resetForm();
  }

  public read(id: number): void {

    this.reset();
    this.isProcessing = true;

    this.empreiteiraService.read(id).subscribe(

      (response: any) => {

        this.form.get('id').setValue(response.id);
        this.form.get('nome').setValue(response.nome);
        this.isEditing = true;
        this.isProcessing = false;
      },
      (error: any) => {
        this.showError(error);
      },
    );
  }

  public submit(): void {

    this.isProcessing = true;

    if (this.form.get('id').value === 0) {
      this.empreiteiraService.isUniqueNomeEmpreiteira(this.form.get('nome').value).subscribe(

        (isUniqueNomeEmpreiteira: boolean) => {

          if (isUniqueNomeEmpreiteira) {
            this.save();
          } else {
            this.form.get('nome').setErrors({ isNotUniqueNomeEmpreiteira: true });
            this.isProcessing = false;
          }
        },
        (error: any) => { this.showError(error); }
      );
    } else {
      this.save();
    }

  }


  public save() {

    this.empreiteiraService.create(this.form.value).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );

  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) { this.voids.push(''); }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, { windowClass: 'smModal', backdrop: 'static'  });
  }

  public delete(id: number, c: any): void {

    this.isProcessing = true;
    c('Close click');

    this.empreiteiraService.delete(id).subscribe(

      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        this.list();
      },
      (error: any) => {
        this.showError(error);
      }
    );
  }

  public showError(error: any) {

    // this.form.get('codigo').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error('Ocorreu um erro no servidor');
    }

    this.isProcessing = false;
  }





}

